import { NavLink, useParams } from "react-router";

import Valkyrie, { viArrowLeft, viSmartphone } from "@sippy-platform/valkyrie";

import { Button, Stack, Typography } from "@mui/material";

export default function MobileSippeerStart() {
  const { pbxId } = useParams();
  return (
    <Stack sx={{ textAlign: "center", pt: 8, alignItems: "center" }}>
      <Typography variant="h1" color="primary">
        <Valkyrie icon={viSmartphone} />
      </Typography>
      <Typography variant="h5">Mobile users</Typography>
      <Typography>Select a mobile user to get started.</Typography>

      <Button
        component={NavLink}
        to={`/pbx/${pbxId}/dashboard`}
        size="small"
        color="inherit"
        startIcon={<Valkyrie icon={viArrowLeft} />}
        sx={{ mt: 8 }}
      >
        Back to Dashboard
      </Button>
    </Stack>
  );
}
